import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";
import UserRoles from "constants/UserRoles";


const breadcrumbsStatic = [{
	name: 'Dispatch',
	url: '/dispatch',
	icon: 'dashboard',
}];

export default class Dispatch extends Framework.Components.View {

	access = [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk];

	render() {
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: "Calendar",
				url: `/dispatch/calendar`,
				icon: 'calendar',
			}
		]);
		return (
			<div className="container-fluid">
				<Collections.MainCalendar
					id={this.props.match.params.id}
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					old={this.props.old}
				/>
			</div>
		);
	}
}


